import React from 'react';
import { useEffect } from 'react';
import NavLink from '../../styledcomponents/NavLink/index'
import './drawer.css'
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import iconSet from "../../icons/selection.json";
import IcomoonReact from "icomoon-react";

const drawerWidth = "25rem";

const useStyles = makeStyles((theme) => ({
    root: {
    },

    hide: {
        display: 'none',
    },
    drawer: {
        zIndex: theme.zIndex.drawer + 1,
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',

        [theme.breakpoints.down('sm')]: {

            zIndex: theme.zIndex.drawer,

        },

    },
    drawerOpen: {

        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        backgroundImage: 'linear-gradient(to right,#606c88,#3f4c6b)',


    },
    drawerlist: {
        width: "100%"

    },


    "@keyframes moveInRight": {
        "0%": {
            opacity: 0,
            transform: "translateX(-550%)"


        },

        "100%": {
            opacity: 1,
            transform: "translateX(0)"
        }
    },

    "@keyframes moveInTop": {
        "0%": {
            opacity: 0,
            transform: "translateY(-200%)"


        },

        "100%": {
            opacity: 1,
            transform: "translateY(0)"
        }
    },

}));

function MDrawer(props) {

    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [screenWidth, setscreenWidth] = React.useState(0)
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const theme = useTheme();


    function handleDrawerToggle() {
        setMobileOpen(!mobileOpen)
    }
    function handleDrawerClose() {
        setMobileOpen(false)
        console.log("WHat")
    }

    function reportWindowSize() {
        var w = window.innerWidth;
        setscreenWidth(w);
        console.log("r")
    }

    window.onresize = reportWindowSize;

    useEffect(() => {
        var w = window.innerWidth;
        setscreenWidth(w);

        window.addEventListener('resize', reportWindowSize);

        return () => {
            window.removeEventListener('resize', reportWindowSize);

        }
    }, [])





    const handleClose = (event) => {
        setAnchorEl(null)
    };



    return (
        <div className={classes.root}>

            <Hidden smUp implementation="css">

                <Drawer
                    variant="temporary"
                    anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                    open={props.mobileOpen}
                    onClose={props.handleDrawerToggle}

                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}

                    classes={{
                        paper: clsx({
                            [classes.drawerOpen]: props.mobileOpen,
                        }),
                    }}

                >

                    <ul className="drawerlist" >

                        <div className="listItem">



                            <NavLink linkTo="home" href="#" onClick={handleDrawerClose}>

                                <IcomoonReact iconSet={iconSet} color="#FFF" className="listIcon" icon="home2" />

                                Home</NavLink>
                        </div>

                        <div className="listItem" >


                            <NavLink linkTo="about" href="#" >
                                <IcomoonReact iconSet={iconSet} color="#FFF" className="listIcon" icon="info-with-circle" />

                                About</NavLink>
                        </div>

                        <div className="listItem">

                            <NavLink linkTo="service" href="#">
                                <IcomoonReact iconSet={iconSet} color="#FFF" className="listIcon" icon="cogs" />

                                Skills</NavLink>
                        </div>

                        <div className="listItem">

                            <NavLink linkTo="resume" href="#">
                                <IcomoonReact iconSet={iconSet} color="#FFF" className="listIcon" icon="profile" />

                                Resume</NavLink>
                        </div>
                        {/* <div className="listItem">

                            <NavLink linkTo="referance" href="#">
                                <IcomoonReact iconSet={iconSet} color="#FFF" className="listIcon" icon="quotes-left" />

                                Reference</NavLink>
                        </div> */}
                        <div className="listItem">

                            <NavLink linkTo="project" href="#">
                                <IcomoonReact iconSet={iconSet} color="#FFF" className="listIcon" icon="quotes-left" />

                                Projects</NavLink>
                        </div>

                        <div className="listItem">

                            <NavLink linkTo="contact" href="#">
                                <IcomoonReact iconSet={iconSet} color="#FFF" className="listIcon" icon="phone-hang-up" />

                                Contact</NavLink>
                        </div>



                    </ul>

                </Drawer>
            </Hidden>

        </div>

    );
}



export default (MDrawer);